/**
 * Centralised namespace for the Helix React Core library.
 * Do not use special characters, numbers or spaces in this value.
 */
export const HELIX_REACT_CORE_TRANSLATION_NAMESPACE = 'helixReactCore';
